<template>
  <div>
    <v-select
      v-if="showSelect"
      :items="branchesList"
      v-model="branchId"
      autocomplete
      :hide-details="hideDetails"
      :label="label"
      :clearable="clearable"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  props: {
    clearable: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: 'Branch *' },
    value: { type: [Number, String], default: null }
  },

  data() {
    return {
      branchesList: [],
      showSelect: false,
      // branchId: 0,
      authUser: {}
    }
  },

  computed: {
    branchId: {
      get() {
        let branch = this.value ? this.value : this.authUser.default_branch_id_fk
        if (!this.value) {
          this.$emit('input', branch)
        }
        return branch
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  // watch: {
  //   value(newValue) {
  //     if (newValue) {
  //       this.branchId = Number(newValue)
  //     } else {
  //       this.branchId = this.authUser.default_branch_id_fk
  //     }
  //   },

  //   branchId(newValue) {
  //     this.$emit('input', newValue)
  //   }
  // },

  mounted() {
    this.getConnectedBranches()
    this.getLoggedInUser()
    this.branchId = this.authUser.default_branch_id_fk
  },

  methods: {
    getLoggedInUser() {
      this.authUser = JSON.parse(localStorage.getItem('user_data'))
    },

    getConnectedBranches() {
      this.branchesList = []
      let token = localStorage.getItem('access_token')
      Axios
        .get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          response.data.forEach(r => {
            this.branchesList.push({ text: r.branch_name, value: r.branch_id })
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/BranchSelect.vue